import { Badge } from '@mantine/core';
import classes from './vacanciesTemplatesStatusBadge.module.scss';

type StatusBageProps = {
  isActive: boolean;
};

export const VacanciesTemplatesStatusBadge = ({
  isActive,
}: StatusBageProps) => {
  return isActive ? (
    <Badge
      variant='light-skill'
      color='green'
      size='sm'
      py={6}
      className={classes.badge}
    >
      Активен
    </Badge>
  ) : (
    <Badge
      variant='light'
      color='tertiary'
      size='sm'
      py={6}
      className={classes.badge}
    >
      Неактивен
    </Badge>
  );
};
